import { render, staticRenderFns } from "./payAfterConfig.vue?vue&type=template&id=0d813db6&scoped=true&"
import script from "./payAfterConfig.vue?vue&type=script&lang=js&"
export * from "./payAfterConfig.vue?vue&type=script&lang=js&"
import style0 from "./payAfterConfig.vue?vue&type=style&index=0&id=0d813db6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d813db6",
  null
  
)

export default component.exports